import React from 'react';
import './PresenceDot.css';

/**
 * The dot beside somebody's name.
 *
 * ONE COMPONENT BECAUSE THERE WAS ONE DOT WRITTEN THREE TIMES - the people
 * list, the conversation header and the group member list each drew their
 * own, each deciding for itself what grey meant. That was survivable while
 * the only question was "has their browser said anything in 90 seconds". It
 * stopped being survivable the moment somebody could CHOOSE what to show:
 * Do not disturb is not Busy, Away is not Offline, and a list that paints two
 * of those the same colour is worse than one that paints none of them.
 *
 * The server sends the state and the label; this draws it and says it out
 * loud. Nothing here decides anything - lib/chat-status.js does, once, for
 * every screen.
 *
 * READ OUT RATHER THAN ONLY SHOWN. A coloured dot is invisible to a screen
 * reader and ambiguous to anyone who does not see the difference between
 * amber and red, so the label goes in the title and in text only a reader
 * sees. "Online" as a bare dot was the old failure and is not worth keeping.
 */
export default function PresenceDot({
  state = 'offline', label = null, detail = null, size = 'md', className = ''
}) {
  const said = [label || state, detail].filter(Boolean).join(' — ');
  return (
    <span
      className={`pd pd-${size}${className ? ` ${className}` : ''}`}
      data-state={state}
      title={said}
    >
      <span className="pd-sr">{said}</span>
    </span>
  );
}
